document.addEventListener("DOMContentLoaded", () => {
  const header1 = document.getElementById("home-header-1");
  const header2 = document.getElementById("home-header-2");

  if (!header1 || !header2) return;
  let lastScroll = 0;

  window.addEventListener("scroll", () => {
    const currentScroll = window.scrollY;

    if (header2.getBoundingClientRect().top <= 0) {
      header1.classList.add("d-none");
    } else {
      header1.classList.remove("d-none");
    }

    if (currentScroll < lastScroll && header2.getBoundingClientRect().top > 0) {
      header1.classList.remove("d-none");
    }

    lastScroll = currentScroll;
  });
});
